module.exports = __webpack_public_path__ + "static/media/planet-simulation.543c655c.mp4";